import ProjectSession from "../../../../../core/model2/project/project-session"
import {SortDirection} from "../../../../../core/data-structures/sort"

// shared by both tags variants: section (tags.tsx) and tree group (tags-group.tsx)

export default function getOrderedTags(tags: ProjectSession[]): ProjectSession[] {

    const sortPositions = gd.user.settings.menu.projectsTags.sortPositions

    return _.orderBy(tags, [
            (item)=>sortPositions.includes(item.id) ? 0 : 1,
            (item)=>_.indexOf(sortPositions, item.id)
        ], [
            SortDirection.ASC,
            SortDirection.ASC
        ])
}
